export default "__VITE_ASSET__CFlq9Hag__"